import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import Vue from "vue";

const state = {
  signedDocumentBundles: [],
  signedDocumentBundleFiles: [],
  currentSignedDocument: null,
};

const getters = {
  signed_documents_get_bundles: (state) => {
    return state.signedDocumentBundles;
  },
  signed_documents_get_bundle_files: (state) => {
    return state.signedDocumentBundleFiles;
  },
  signed_documents_get_current_document: (state) => {
    return state.currentSignedDocument;
  },
};

const mutations = {
  SIGNED_DOCUMENTS_SET_BUNDLES(state, bundles) {
    state.signedDocumentBundles = bundles;
  },
  SIGNED_DOCUMENTS_SET_BUNDLE_FILES(state, data) {
    console.log(">>>>>>>>> SIGNED_DOCUMENTS_SET_BUNDLE_FILES", data.document, data.files);
    // state.signedDocumentBundleFiles[data.document] = data.files
    Vue.set(state.signedDocumentBundleFiles, data.document, data.files);
    console.log(">>>>>>>>> SIGNED_DOCUMENTS_SET_BUNDLE_FILES", state.signedDocumentBundleFiles);
  },
  SIGNED_DOCUMENTS_RESET_BUNDLE_FILES(state) {
    state.signedDocumentBundleFiles = [];
  },
  SIGNED_DOCUMENTS_SET_CURRENT_DOCUMENT(state, document) {
    state.currentSignedDocument = document;
  },
};

const actions = {
  getSignedDocumentBundles({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "5",
        order_col: payload.params.order_col ? payload.params.order_col : "created_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsGet(params)
            .then((res) => {
              console.log("getSignedDocumentsBundles", res);
              commit("SIGNED_DOCUMENTS_SET_BUNDLES", res.data.data);
              commit("SIGNED_DOCUMENTS_RESET_BUNDLE_FILES");
              res.data.data.forEach((bundle) => {
                dispatch("getSignedDocumentBundleFiles", {
                  project: payload.project,
                  document: bundle.uid,
                });
              });
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "signedDocuments",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              // commit('LIBRARY_SET_LIBRARY_FOLDER_LIST', [])
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              console.log("error", err);
              reject(err);
            });
        })
        .catch((err) => {
          // commit('LIBRARY_SET_LIBRARY_FOLDER_LIST', [])
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          console.log("error", err);
          reject(err);
        });
    });
  },
  getSignedDocumentBundleFiles({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.project,
        document: payload.document,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "1000",
        order_col: payload.params.order_col ? payload.params.order_col : "title",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
        external_id: payload.params.external_id ? payload.params.external_id : "",
        type: payload.params.type ? payload.params.type : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesGet(params)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentFilesGet", res);
              commit("SIGNED_DOCUMENTS_SET_BUNDLE_FILES", {
                document: payload.document,
                files: res.data.data,
              });
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              // commit('LIBRARY_SET_LIBRARY_FOLDER_LIST', [])
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              console.log("error", err);
              reject(err);
            });
        })
        .catch((err) => {
          // commit('LIBRARY_SET_LIBRARY_FOLDER_LIST', [])
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          console.log("error", err);
          reject(err);
        });
    });
  },
  getSignedDocument({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentGet(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createSignedDocument({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsPost", res);
              commit("SIGNED_DOCUMENTS_SET_CURRENT_DOCUMENT", res.data.data.uid);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteSignedDocument({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentDelete(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentDelete", res);
              commit("SIGNED_DOCUMENTS_SET_CURRENT_DOCUMENT", {});
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  startSignedDocumentSigningProcess({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentSignPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentSignPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getSignedDocumentSigningUrl({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentSigningurlGet(params)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentSigningurlGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getSignedDocumentFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesFileGet(params)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentFilesFileGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getDownloadSignedDocumentFileUrl({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesFileDownloadGet(params)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentFilesFileDownloadGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createSignedDocumentFiles({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      console.log(">>> $$$$$$ >>>>> START createSignedDocumentFiles", payload);
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentFilesPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editSignedDocumentFile({ commit, dispatch, rootState }, payload) {
    console.log("hey");
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesFilePut(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentFilesFilePut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response, { name: "file" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteSignedDocumentFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesFileDelete(params, {})
            .then((res) => {
              console.log("teamProjectsProjectSigneddocumentsDocumentFilesFileDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getSignedDocumentFilePreview({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        team: payload.team,
        project: payload.project,
        document: payload.document,
        file: payload.file,
        page: payload.params.page ? payload.params.page : "1",
        width: payload.params.width ? payload.params.width : "100",
        height: payload.params.height ? payload.params.height : "100",
        rendermethod: payload.params.rendermethod ? payload.params.rendermethod : "fit",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      console.log("------------------- getSignedDocumentFilePreview", payload);
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSigneddocumentsDocumentFilesFilePreviewImageRendermethodPageWidthHeightGet(params)
            .then((res) => {
              console.log(
                "teamProjectsProjectSigneddocumentsDocumentFilesFilePreviewImageRendermethodPageWidthHeightGet",
                res.data.data
              );
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
